{
  "instances": {
    "httptrace": {
      "label": "HTTP Traces",
      "chart": {
        "avg_time": "ø duración",
        "max_time": "duración máxima",
        "status_4xx": "estado 4xx",
        "status_5xx": "estado 5xx",
        "successful_requests": "solicitudes exitosas",
        "total_requests": "solicitudes totales"
      },
      "content_type_response": "Response Content-Type",
      "content_type_request": "Request Content-Type",
      "length_request": "Request Length",
      "fetching_failed": "Falla recuperando la traza.",
      "limit": "límite",
      "filter": {
        "client_errors": "Errores de clientes",
        "exclude_actuator": "excluir {actuator}/**",
        "server_errors": "errores de servidor",
        "success": "éxito"
      },
      "length_response": "Response Length",
      "method": "Método",
      "no_traces_found": "No se encontraron trazas.",
      "status": "Estado",
      "time": "Duración",
      "timestamp": "Horario",
      "uri": "Path"
    }
  }
}
